'use client';

import type React from 'react';
import { useAnalytics } from '@/hooks/use-analytics';

interface AnalyticsProviderProps {
  gaId: string;
  children: React.ReactNode;
}

export function AnalyticsProvider({ gaId, children }: AnalyticsProviderProps) {
  // Track page views on route changes
  useAnalytics(gaId);

  return <>{children}</>;
}
